import { useEffect, useState } from "react";

/** A CSS media query as React state, re-evaluated when the viewport crosses it. */
export function useMedia(query: string): boolean {
  const [match, setMatch] = useState(() => matchMedia(query).matches);
  useEffect(() => {
    const mq = matchMedia(query);
    const onChange = () => setMatch(mq.matches);
    onChange(); // a resize between the first render and this effect would otherwise go unnoticed
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);
  return match;
}
